module.exports = __webpack_public_path__ + "img/hr-green-bush-mini-03.7d968c0c.png";